import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import Logo from 'assets/images/header/logo.png';
import { ProfileMenu } from 'templates/Header';
import Clock from 'react-live-clock';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { FaRegCircleUser } from 'react-icons/fa6';

export const Header: React.FC = () => {
  const [openProfile, setOpenProfile] = useState<boolean>(false);
  const { auth } = useSelector((state: RootState) => state.auth);

  const profileMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target as Node)
      ) {
        setOpenProfile(false);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const getGreetingMessage = () => {
    const hour = new Date().getHours();

    if (hour >= 12) {
      if (hour >= 16) {
        return 'Good Evening !';
      } else {
        return 'Good Afternoon !';
      }
    } else {
      return 'Good Morning !';
    }
  };

  return (
    <div className='w-full h-[3.5rem] bg-gray-100 px-4 md:px-8'>
      <div className='flex justify-between items-center h-full'>
        <img
          src={Logo}
          alt='logo'
          className='w-[7rem] lg:w-[8rem]'
        />
        <div className='gap-5 flex items-center'>
          <div className='md:block hidden'>
            <div className='w-36 h-11 text-red-600 tracking-widest text-sm font-bold rounded-sm mr-6 flex flex-col justify-center items-center'>
              <span className='text-[11px]'>
                {moment(new Date()).format('DD/MM/YYYY')}
              </span>{' '}
              <Clock
                format={'HH:mm:ss'}
                ticking={true}
                timezone='Europe/London'
              />
            </div>
          </div>

          <div className='font-display font-bold text-xs flex-col text-gray-900 tracking-widest mr-6 md:block hidden'>
            <span className='text-[12px]'>{getGreetingMessage()}</span>
            <br />
            Admin
          </div>
          <div className='flex gap-6 items-center'>
            <div
              className='relative'
              ref={profileMenuRef}
            >
              <FaRegCircleUser
                onClick={() => setOpenProfile(!openProfile)}
                className='h-7 md:h-8 w-7 md:w-8 rounded-full text-indigo-900 hover:border-[2px] hover:border-red-400 cursor-pointer'
              />
              {openProfile && (
                <div className='absolute top-10 right-0'>
                  <ProfileMenu auth={auth} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
